import {makeActionCreator} from '../utility'

export const FETCH_FILE = 'FETCH_FILE'
export const fetchFile = makeActionCreator(FETCH_FILE, 'data')

export const FILE_RECEIVED = 'FILE_RECEIVED'
export const fileReceived= makeActionCreator(FILE_RECEIVED, 'data')
